import React from 'react';

interface LocationExpiredModalProps {
  onRefresh: () => void;
  language: 'en' | 'es';
}

const translations = {
  en: {
    title: 'Location Expired',
    refresh: 'REFRESH'
  },
  es: {
    title: 'Ubicación Expirada',
    refresh: 'ACTUALIZAR'
  }
};

export const LocationExpiredModal: React.FC<LocationExpiredModalProps> = ({
  onRefresh,
  language
}) => {
  const t = translations[language];

  return (
    <div className="location-expired-backdrop">
      <div className="location-expired-modal">
        <div className="location-expired-icon">⚠️</div>
        <h2 className="location-expired-title">{t.title}</h2>
        <button className="location-expired-btn" onClick={onRefresh}>
          {t.refresh}
        </button>
      </div>
    </div>
  );
};
